import { AdminProfileFieldsNames, TAdminProfileFormValues } from '../helpers/types';
import { IAdminDetailsDTO } from '@/models/users.model';

class AdminProfileDTO implements Partial<IAdminDetailsDTO> {
  first_name;
  last_name;

  constructor(values: TAdminProfileFormValues) {
    this.first_name = values[AdminProfileFieldsNames.FIRST_NAME];
    this.last_name = values[AdminProfileFieldsNames.LAST_NAME];
  }
}

export default AdminProfileDTO;
